import type { CSSProperties } from 'react';

/** Discipline colour as CSS custom property (used by cards, chips, icons). */
export const dc = (k: string) => ({ '--dc': `var(--d-${k})` }) as CSSProperties;
